var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header"},[_c('b-row',[_c('b-col',[_c('icon-deposit',{staticClass:"icon",attrs:{"height":26,"width":26,"color":"#FFD102"}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("sidebar.deposit")))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }